import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { getLocalStoreDefaultPrice, getUserData, setLocalStoreDefaultPrice } from "../../utils/localStorage";
import { storeCustomerGetInfo } from "../../services/CustomerInfo/CustomerInfo";
import {
  getCustomerSingleOrderGarmentServiceInfo,
  getCustomerSingleOrderInfo,
  getOrderDocs,
  getStoreUserFullInfo,
} from "../../services/OrdersAPI/Orders";
import { getReadyToDeliveryQrCode } from "../../services/QrCode/getReadyToDeliveryQrCode";
import { getOrderPaymentDetails } from "../../services/OrderPayment/orderPayment";
import { postQrCodeByStatus } from "../../services/QrCode/postQrCodeByStatus";
import { getStoreDefaultPrice } from "../../services/StoreDefaultPrice/getStoreDefaultPrice";
import OrderInfoCard from "./OrderInfoCard";
import PaymentInfoCard from "./PaymentInfoCard";
import PackageInfoCard from "./PackageInfoCard";
import GarmentInfoCard from "./GarmentInfoCard";
import { Button } from "primereact/button";
import OrderCancelModal from "./OrderCancelModal";
import OrderInfoEdit from "./OrderInfoEdit";
import OrderUnprocessedQrCode from "./OrderUnprocessedQrCode";
import CollectPayment from "./CollectPayment";
import SuccessModal from "../SuccessModal";
import StoreMenu from "../StoreMenu";
import OrderNotification from "./OrderNotification";
import { OverlayPanel } from "primereact/overlaypanel";
import { useRef } from "react";
import { ListBox } from "primereact/listbox";
import OrderInfoEditByProfile from "./OrderInfoEditByProfile";
import { getQrCodeByItem } from "../../services/QrCode/getQrCode";
import ButtonLink from "../../ButtonLink";
import { postBulkQrCode } from "../../services/QrCode/postBulkQrCode";
import { getOrderSubscriptionInfo } from "../../services/LoyaltyPoint/LoyaltyPoint";
import CollectPaymentSubscriptionClosedModal from "./CollectPaymentSubscriptionClosedModal";
import { OrderEditWithType } from "../../services/StoreOrder/StoreOrder";

import { Pencil, Lock } from "lucide-react";
import { maskMobileNumber } from "../../constants/DateUtil/DateUtil";

const { innerWidth: width, innerHeight: height } = window;


const styles = {
  track: (editing) => ({
    position: "relative",
    width: 112,
    height: 35,
    borderRadius: 999,
    border: `1.5px solid ${editing ? "#8FD4A6" : "#e3d7d7"}`,
    backgroundColor: editing ? "#E4F5E9" : "#f5eeee",
    overflow: "hidden",
    cursor: "pointer",
    transition: "background-color 300ms, border-color 300ms",
    padding: 0,
  }),
  label: (editing) => ({
    position: "absolute",
    inset: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: 13.5,
    fontWeight: 600,
    color: editing ? "#1F7A38" : "#745b5b",
    paddingLeft: editing ? 6 : 34,
    paddingRight: editing ? 34 : 6,
    transition: "padding 300ms, color 300ms",
    boxSizing: "border-box",
  }),
  thumb: (editing) => ({
    position: "absolute",
    top: 3,
    left: editing ? "calc(100% - 36px)" : 4,
    height: 26,
    width: 26,
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: editing ? "#2FA84F" : "#ad9494",
    boxShadow: "0 1px 3px rgba(0,0,0,0.2)",
    transition: "left 300ms cubic-bezier(.4,1.4,.6,1), background-color 300ms",
  }),
  icon: (visible, editing) => ({
    position: "absolute",
    opacity: visible ? 1 : 0,
    transform: visible
      ? "scale(1) rotate(0deg)"
      : `scale(0.4) rotate(${editing ? -45 : 45}deg)`,
    transition: "opacity 200ms, transform 200ms",
  }),
};

const CardDataBeforeProcessOrder = [
  {
    id: 1,
    name: "Mark Ready",
    fillColor: "#E7F4FF",
    borderColor: "#3EB3E1",
    img: "Laundy_App_Icons_Gifs/Other_Icons/Process_Order.png",
  },
  {
    id: 2,
    name: "Cancel Order",
    fillColor: "#FFEEEE",
    borderColor: "#FF6767",
    img: "Laundy_App_Icons_Gifs/Other_Icons/Cancel_Order.png",
  },
  {
    id: 3,
    name: "Order Invoice",
    fillColor: "#FFF9DE",
    borderColor: "#F5C43A",
    img: "Laundy_App_Icons_Gifs/Other_Icons/View_Invoice.png",
  },
  {
    id: 4,
    name: "Garment Tag",
    fillColor: "#E4FFE6",
    borderColor: "#55BD5A",
    img: "Laundy_App_Icons_Gifs/Other_Icons/View_QR_Code.png",
  },
];

const CardDataOnNoOrderProcess = [
  {
    id: 1,
    name: "Mark Ready",
    fillColor: "#E7F4FF",
    borderColor: "#3EB3E1",
    img: "Laundy_App_Icons_Gifs/Other_Icons/Process_Order.png",
  },
  {
    id: 2,
    name: "Order Invoice",
    fillColor: "#FFF9DE",
    borderColor: "#F5C43A",
    img: "Laundy_App_Icons_Gifs/Other_Icons/View_Invoice.png",
  },
  {
    id: 3,
    name: "Garment Tag",
    fillColor: "#E4FFE6",
    borderColor: "#55BD5A",
    img: "Laundy_App_Icons_Gifs/Other_Icons/View_QR_Code.png",
  },
];

const CardDataAfterOneGarmentProcessInOrder = [
  {
    id: 1,
    name: "Mark Ready",
    fillColor: "#E7F4FF",
    borderColor: "#3EB3E1",
    img: "Laundy_App_Icons_Gifs/Other_Icons/Process_Order.png",
  },
  {
    id: 2,
    name: "Deliver Order",
    fillColor: "#E7F4FF", // You can set the desired colors
    borderColor: "#3EB3E1", // You can set the desired colors
    img: "Laundy_App_Icons_Gifs/Other_Icons/Deliver_Order.png", // Provide the correct image path
  },
  {
    id: 3,
    name: "Order Invoice",
    fillColor: "#FFF9DE",
    borderColor: "#F5C43A",
    img: "Laundy_App_Icons_Gifs/Other_Icons/View_Invoice.png",
  },
  {
    id: 4,
    name: "Garment Tag",
    fillColor: "#E4FFE6",
    borderColor: "#55BD5A",
    img: "Laundy_App_Icons_Gifs/Other_Icons/View_QR_Code.png",
  },
];

const CardDataAfterProcessOrder = [
  {
    id: 1,
    name: "Deliver Order",
    fillColor: "#E7F4FF", // You can set the desired colors
    borderColor: "#3EB3E1", // You can set the desired colors
    img: "Laundy_App_Icons_Gifs/Other_Icons/Deliver_Order.png", // Provide the correct image path
  },
  {
    id: 2,
    name: "Order Invoice",
    fillColor: "#FFF9DE",
    borderColor: "#F5C43A",
    img: "Laundy_App_Icons_Gifs/Other_Icons/View_Invoice.png",
  },
  {
    id: 3,
    name: "Garment Tag",
    fillColor: "#E4FFE6",
    borderColor: "#55BD5A",
    img: "Laundy_App_Icons_Gifs/Other_Icons/View_QR_Code.png",
  },
];

const CardDataOnDoneOrder = [
  {
    id: 1,
    name: "Order Invoice",
    fillColor: "#FFF9DE",
    borderColor: "#F5C43A",
    img: "Laundy_App_Icons_Gifs/Other_Icons/View_Invoice.png",
  },
  {
    id: 2,
    name: "Garment Tag",
    fillColor: "#E4FFE6",
    borderColor: "#55BD5A",
    img: "Laundy_App_Icons_Gifs/Other_Icons/View_QR_Code.png",
  },
];

const CardDataOnDeliveredOrder = [
  {
    id: 1,
    name: "Collect Payment",
    fillColor: "#FFF9DE", // You can set the desired colors
    borderColor: "#F5C43A", // You can set the desired colors
    img: "Laundy_App_Icons_Gifs/Packages_GIFs/package4.gif", // Provide the correct image path
  },
  {
    id: 2,
    name: "Order Invoice",
    fillColor: "#FFF9DE",
    borderColor: "#F5C43A",
    img: "Laundy_App_Icons_Gifs/Other_Icons/View_Invoice.png",
  },
  {
    id: 3,
    name: "Garment Tag",
    fillColor: "#E4FFE6",
    borderColor: "#55BD5A",
    img: "Laundy_App_Icons_Gifs/Other_Icons/View_QR_Code.png",
  },
];

const CardDataAfterCancelOrder = [
  {
    id: 1,
    name: "Canceled Order",
    // fillColor: '#E7F4FF', // You can set the desired colors
    borderColor: "red", // You can set the desired colors
    img: "Laundy_App_Icons_Gifs/Customer_Info_GIFs/Cancel_Order.gif", // Provide the correct image path
  },
];

const CardDataUserRiderOrder = [
  {
    id: 1,
    name: "Cancel Order",
    fillColor: "#FFEEEE",
    borderColor: "#FF6767",
    img: "Laundy_App_Icons_Gifs/Other_Icons/Cancel_Order.png",
  },
  {
    id: 2,
    name: "Order Invoice",
    fillColor: "#FFF9DE",
    borderColor: "#F5C43A",
    img: "Laundy_App_Icons_Gifs/Other_Icons/View_Invoice.png",
  },
  {
    id: 3,
    name: "Garment Tag",
    fillColor: "#E4FFE6",
    borderColor: "#55BD5A",
    img: "Laundy_App_Icons_Gifs/Other_Icons/View_QR_Code.png",
  },
];

const CardDataUserRiderOFDBAOrder = [
  {
    id: 1,
    name: "Deliver Order",
    fillColor: "#E7F4FF", // You can set the desired colors
    borderColor: "#3EB3E1", // You can set the desired colors
    img: "Laundy_App_Icons_Gifs/Other_Icons/Deliver_Order.png",
  },
  {
    id: 2,
    name: "Order Invoice",
    fillColor: "#FFF9DE",
    borderColor: "#F5C43A",
    img: "Laundy_App_Icons_Gifs/Other_Icons/View_Invoice.png",
  },
  {
    id: 3,
    name: "Garment Tag",
    fillColor: "#E4FFE6",
    borderColor: "#55BD5A",
    img: "Laundy_App_Icons_Gifs/Other_Icons/View_QR_Code.png",
  },
];

const CardDataOnPartialDeliveryOrder = [
  {
    id: 1,
    name: "Collect Payment",
    fillColor: "#FFF9DE", // You can set the desired colors
    borderColor: "#F5C43A", // You can set the desired colors
    img: "Laundy_App_Icons_Gifs/Packages_GIFs/package4.gif", // Provide the correct image path
  },
  {
    id: 2,
    name: "Deliver Order",
    fillColor: "#E7F4FF", // You can set the desired colors
    borderColor: "#3EB3E1", // You can set the desired colors
    img: "Laundy_App_Icons_Gifs/Other_Icons/Deliver_Order.png",
  },
  {
    id: 3,
    name: "Order Invoice",
    fillColor: "#FFF9DE",
    borderColor: "#F5C43A",
    img: "Laundy_App_Icons_Gifs/Other_Icons/View_Invoice.png",
  },
  {
    id: 4,
    name: "Garment Tag",
    fillColor: "#E4FFE6",
    borderColor: "#55BD5A",
    img: "Laundy_App_Icons_Gifs/Other_Icons/View_QR_Code.png",
  },
];

function EditModePill({ editing, setEditing, loading = false }) {
 return (
    <button
      onClick={() => !loading && setEditing(!editing)}
      aria-pressed={editing}
      disabled={loading}
      style={{
        ...styles.track(editing),
        opacity: loading ? 0.65 : 1,
        cursor: loading ? "default" : "pointer",
        pointerEvents: loading ? "none" : "auto",
      }}
    >
      <span style={styles.label(editing)}>
        {loading ? "Updating..." : editing ? "Edit on" : "Edit off"}
      </span>

      <span style={styles.thumb(editing)}>
        {loading ? (
          <span
            style={{
              width: 12,
              height: 12,
              borderRadius: "50%",
              border: "2px solid rgba(255,255,255,0.4)",
              borderTopColor: "white",
              animation: "spin 700ms linear infinite",
            }}
          />
        ) : (
          <>
            <Pencil size={14} color="white" strokeWidth={2.4} style={styles.icon(editing, editing)} />
            <Lock size={14} color="white" strokeWidth={2.4} style={styles.icon(!editing, editing)} />
          </>
        )}
      </span>
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
    </button>
  );
 }

const OrdersGarmentInfo = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { storeCustomerId, bookingOrderId, bookingOrderNo, navigateThrough, callThrough } =
    location.state || {}; // Fallback to prevent undefined errors

  const {
    brandProfileData,
    storeData,
    userProfileData,
    userProfileRole,
    garmentCategoryServiceIconsResData,
  } = getUserData();

  const storeId = storeData.id;
  const userRole = userProfileRole;
  const userProfileId = userProfileData.id;

  let brandId = brandProfileData.id;
  const storeUserId = userProfileData.id;
  const storeCreatedDate = storeData?.createdDate;
  const processTime = storeData.processTime;
  let deliveryDiscount = storeData.enableDeliveryDiscount;
  let riderDeliveryDiscount = storeData.enableRiderDeliveryDiscount; // rider feature is not required
  let partialPaymentByRider = storeData.partialPaymentByRider; // rider feature is not required
  let orderEditByStore = storeData.orderEditByStore;
  let orderEditByRider = storeData.orderEditByRider;
  let enableDeliveryVerification = storeData.enableDeliveryVerification; // rider feature is not required
  let enableDeliveryVerificationByRider =
    storeData.enableDeliveryVerificationByRider; // rider feature is not required
  let enableDeliveryVerificationByStore =
    storeData.enableDeliveryVerificationByStore; // rider feature is not required
  let enableUserAccountDeliveryDiscount =
    storeData.enableUserAccountDeliveryDiscount;
  const enabledChargeDiscountByService =
    storeData.enabledChargeDiscountByService;
  const enabledCustomDiscountCharge = storeData.enabledCustomDiscountCharge;
  let enabledCreatePaymentLink = storeData.enabledCreatePaymentLink;
  let enabledGarmentInspection = storeData.enabledGarmentInspection;
  let enabledSubscriptionDiscountOnDelivery =
    storeData.enabledSubscriptionDiscountOnDelivery;
  let offerPriceEnabled = storeData.offerPriceEnabled;
  let enabledByPassOrderProcess = brandProfileData.enabledByPassOrderProcess;
  let enabledRfIdModal = brandProfileData.enabledRfIdModal;
  let enableCancelOrder = storeData.enableCancelOrder;
  const garmentMaxProcessCount = brandProfileData.garmentMaxProcessCount;
  let enabledBackDate = storeData.enabledBackDate;
  let enabledEditPayment = storeData.enabledEditPayment;
  const enabledApplySubscriptionWithPackage = storeData.enabledApplySubscriptionWithPackage;
  const enabledAutoApplySubscriptionWithPackage = storeData.enabledAutoApplySubscriptionWithPackage;
  let enabledUPIAccount = storeData.enabledUPIAccount;
  let upiAccountId = storeData.upiAccountId;
  let upiAccountLink = storeData.upiAccountLink;
  let upiAccountName = storeData.upiAccountName;
  let enabledQRDeviceModal = storeData.enabledQRDeviceModal;
  const enabledAmountRoundOff = storeData.enabledAmountRoundOff ? 0 : 2;
  let enabledOrderBulkEdit = storeData.enabledOrderBulkEdit;

  const offerDiscountByStore = storeData.offerDiscountByStore;
  const offerDiscountByRider = storeData.offerDiscountByRider;

  const [processOrderActive, setProcessOrderActive] = useState(null);
  const [cancelOrderModal, setCancelOrderModal] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [modalText, setModalText] = useState("");
  const [modalStatusText, setModalStatusText] = useState("");
  const [showDeliveryOrder, setShowDeliveryOrder] = useState("");
  const [showCancelOrder, setShowCancelOrder] = useState(false);
  const [customerOrdersData, setCustomerOrdersData] = useState({});
  const [
    customerOrdersGarmentServiceInfoData,
    setCustomerOrdersGarmentServiceInfoData,
  ] = useState({});
  const [storeCustomerData, setStoreCustomerData] = useState({});
  const [collectPaymentModalVisible, setCollectPaymentModalVisible] =
    useState(false);
  const [collectPaymentSubscriptionClosedModalVisible, setCollectPaymentSubscriptionClosedModalVisible] =
    useState(false);
  const [
    deliverOrderWithAuthCodeModalVisible,
    setDeliverOrderWithAuthCodeModalVisible,
  ] = useState(false); // rider feature is not required

  const [orderNotificationVisible, setOrderNotificationVisible] =
    useState(false);
  const [orderNotificationMessageType, setOrderNotificationMessageType] =
    useState("");
  const [refreshing, setRefreshing] = useState(false);
  const [orderInfoEditVisible, setOrderInfoEditVisible] = useState(false);
  const [orderUnprocessedQrCode, setOrderUnprocessedQrCode] = useState(false);
  const [storeDefaultPrice, setStoreDefaultPrice] = useState([]);
  const [orderPaymentDetailsData, setOrderPaymentDetailsData] = useState([]);
  const [processGarment, setProcessGarment] = useState(false);
  const [visible, setVisible] = useState(false);
  const [orderInfoEditByProfileVisible, setOrderInfoEditByProfileVisible] =
    useState(false);
  const [orderEditMode, setOrderEditMode] = useState("")

  const [orderSubscriptionInfo, setOrderSubscriptionInfo] = useState({})

  const op = useRef(null);

  const [selectedInfoType, setSelectedInfoType] = useState({
    name: "Garment Info",
    code: "Garment Info",
  });
  const InfoType = [
    { name: "Garment Info", code: "Garment Info" },
    { name: "Service Info", code: "Service Info" },
  ];

  const handleBackButton = () => {
    if (userRole === "BY_STORE") {
      if (navigateThrough === "GoBack") {
        navigate(-1);
      } else {
        navigate("/CustomerInfo", {
          state: {
            storeCustomerId: storeCustomerId,
          },
        });
      }
    } else {
      navigate("/");
    }
  };

  const fetchStoreCustomerGetInfo = () => {
    storeCustomerGetInfo(storeCustomerId, storeId)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          setStoreCustomerData(Res);
        }
      })
      .catch((err) => {
        console.error("storeCustomerGetInfo Error:", err);
      });
  };

  const fetchCustomerSingleOrder = () => {
    // getCustomerSingleOrder(storeCustomerId, storeId, bookingOrderId)
    getCustomerSingleOrderInfo(storeCustomerId, storeId, bookingOrderId)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          setCustomerOrdersData(Res);
          setOrderEditMode(Res?.orderUnderEdit)

          if (Res.subscriptionDiscount > 0) {
            getOrderSubscriptionInfo(storeId, storeCustomerId, bookingOrderId)
              .then((response) => {
                if (!response.data.error) {
                  const customerOrdersDataRes = response.data;
                  setOrderSubscriptionInfo(customerOrdersDataRes)
                }
              })
              .catch((err) => {
                console.error("Error:", err);
              });
          }
        }
      })
      .catch((err) => {
        console.error("getCustomerSingleOrder Error:", err);
      });

    getCustomerSingleOrderGarmentServiceInfo(
      storeCustomerId,
      storeId,
      bookingOrderId
    )
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          setCustomerOrdersGarmentServiceInfoData(Res);
        }
      })
      .catch((err) => {
        console.error("getCustomerSingleOrder Error:", err);
      });

    getReadyToDeliveryQrCode(storeCustomerId, storeId, bookingOrderId)
      .then((response) => {
        if (!response.data.error) {
          if (
            response.data.processedList.length > 0 ||
            response.data.readyToDeliveryList.length > 0
          ) {
            setProcessGarment(true);
          } else {
            setProcessGarment(false);
          }
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });

    getOrderPaymentDetails(storeCustomerId, storeId, bookingOrderId)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          setOrderPaymentDetailsData(Res);
        }
      })
      .catch((err) => {
        console.error("getCustomerSingleOrder Error:", err);
      });
  };

  const fetchOrderDocs = () => {
    // getCustomerSingleOrder(storeCustomerId, storeId, bookingOrderId)
    getOrderDocs(storeCustomerId, storeId, bookingOrderId)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
        }
      })
      .catch((err) => {
        console.error("getCustomerSingleOrder Error:", err);
      });
  };

  // store in local storage
  const fetchDefaultPrice = async () => {
    try {
      const response = await getStoreDefaultPrice(storeId);
      if (!response.data.error) {
        const Res = response.data;
        setStoreDefaultPrice(Res);
        setLocalStoreDefaultPrice(Res);
      }
    } catch (err) {
      console.error("Error:", err);
    }
  };

  const fetchLocalStoreDefaultPrice = async () => {
    const { storeDefaultPrice } = getLocalStoreDefaultPrice();
    if (storeDefaultPrice && Object.keys(storeDefaultPrice).length > 0) {
      setStoreDefaultPrice(storeDefaultPrice);
    } else {
      await fetchDefaultPrice();
    }
  };

  const [readyToDeliveryUnprocessedData, setReadyToDeliveryUnprocessedData] =
    useState([]);

  const fetchGetDeliveryQrCode = (data) => {
    postQrCodeByStatus(storeCustomerId, storeId, bookingOrderId, data)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          setReadyToDeliveryUnprocessedData(Res);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };

  const [collectPaymentResponse, setCollectPaymentResponse] = useState(null);

  const receiveResponse = ({ message, status, modalFun }) => {
    setModalStatusText(status === "success" || true ? "success" : "failed");
    setModalText(message);
    setCollectPaymentResponse(modalFun);
    fetchCustomerSingleOrder();
    const data = {
      // status: ['OUT_FOR_DELIVERY'], // no need to do this
      status: ["UNPROCESSED"],
    };
    fetchGetDeliveryQrCode(data);
    // setCollectPaymentModalVisible(modalFun);
  };

  const receiveResponseCollectPaymentQrCode = ({ modalFun }) => {
    fetchCustomerSingleOrder();
    const data = {
      // status: ['OUT_FOR_DELIVERY'], // no need to do this
      status: ["UNPROCESSED"],
    };
    fetchGetDeliveryQrCode(data);
  };

  useEffect(() => {
    if (collectPaymentResponse === false) {
      setModalVisible(true);
      setCollectPaymentResponse(null);
    }
  }, [collectPaymentResponse]);

  useEffect(() => {
    fetchCustomerSingleOrder();
    fetchStoreCustomerGetInfo();
    const data = {
      // status: ['OUT_FOR_DELIVERY'], // no need to do this
      status: ["UNPROCESSED"],
    };
    fetchGetDeliveryQrCode(data);
    fetchLocalStoreDefaultPrice();
    if (callThrough === "CartPage") {
      fetchOrderDocs();
    }

    // const handleMessage = () => {
    //   const mobile = "8750001881";
    //   const body = `adasd`;
    //   const countryCode = "+91"

    //   if (!mobile) {
    //     return alert('Mobile number is invalid');
    //   }

    //   // Remove any non-numeric characters and check if the number starts with a '+'
    //   let formattedMobile = mobile.replace(/[^\d+]/g, '');  // Remove non-numeric and non-plus characters

    //   if (!formattedMobile.startsWith('+')) {
    //     formattedMobile = `${countryCode}${formattedMobile}`;  // Add country code only if not already present
    //   }

    //   let url = '';

    //   if (orderNotificationMessageType === 'SMSMessage') {
    //     url = `sms:${formattedMobile}?body=${encodeURIComponent(body)}`;
    //   } else {
    //     url = `https://api.whatsapp.com/send?text=${encodeURIComponent(body)}&phone=${formattedMobile}`;
    //   }

    //   window.open(url, '_blank');
    // };

    // handleMessage()
  }, []);

  useEffect(() => {
    let intervalId;

    if (customerOrdersData?.documentScheduled) {
      intervalId = setInterval(() => {
        fetchCustomerSingleOrder();
        if (!customerOrdersData?.documentScheduled) {
          clearInterval(intervalId);
        }
      }, 5000);
    }

    return () => {
      if (intervalId) clearInterval(intervalId);
    };
  }, [customerOrdersData?.documentScheduled]);


  const CustomerInformation = {
    firstName: storeCustomerData?.brandCustomer?.firstName
      ? storeCustomerData?.brandCustomer?.firstName
      : "",
    lastName: storeCustomerData?.brandCustomer?.lastName
      ? storeCustomerData?.brandCustomer?.lastName
      : "",
    mobile: storeCustomerData?.brandCustomer?.mobile
      ? storeCustomerData?.brandCustomer?.mobile
      : "N/A",
  };

  const selectedUnprocessedQrCodeItems = readyToDeliveryUnprocessedData.map(
    (item) => ({
      id: item.id,
      qrcode: item.qrcode,
      checked: true,
    })
  );

  const orderInfoDetailsBalanceAmount = {
    balanceAmount: customerOrdersData?.balanceAmount
      ? customerOrdersData?.balanceAmount
      : 0,
  };

  const orderItemData = customerOrdersData?.orderItem;
  const b2BChallanOrder = customerOrdersData?.b2BChallanOrder;

  const hasProcessedGarment = orderItemData?.some(
    item => item.status === "PROCESSED"
  ) || false;

  const orderItemGarmentServiceInfoData =
    customerOrdersGarmentServiceInfoData.serviceWiseGarment;
  const orderPackageData = customerOrdersData?.orderPackage;

  const receiveDataFromCancelModal = ({ dataRes }) => {
    // setSchedularDate(newSchedular);
    if (dataRes) {
      fetchCustomerSingleOrder();
    }
  };

  const onUserRiderSelection = (item) => {
    if (item.id === 1) {
      setCancelOrderModal(true);
    } else if (item.id === 2) {
      navigate("/ViewInvoice", {
        state: {
          bookingOrderId: bookingOrderId,
          storeCustomerId: storeCustomerId,
        },
      });
    } else if (item.id === 3) {
      navigate("/ViewQrCode", {
        state: {
          bookingOrderId: bookingOrderId,
          storeCustomerId: storeCustomerId,
        },
      });
    } else {
      navigate("/");
    }
  };

  const onSelectCategoryBeforeProcessOrder = (item) => {
    if (item.id === 1) {
      navigate("/PartialMarkReady", {
        state: {
          storeCustomerId: storeCustomerId,
          bookingOrderId: bookingOrderId,
        },
      });
    } else if (item.id === 2) {
      setCancelOrderModal(true);
    } else if (item.id === 3) {
      navigate("/ViewInvoice", {
        state: {
          bookingOrderId: bookingOrderId,
          storeCustomerId: storeCustomerId,
        },
      });
    } else if (item.id === 4) {
      navigate("/ViewQrCode", {
        state: {
          bookingOrderId: bookingOrderId,
          storeCustomerId: storeCustomerId,
        },
      });
    } else {
      navigate("/");
    }
  };

  const onSelectCategoryOnNoOrderProcess = (item) => {
    if (item.id === 1) {
      navigate("/PartialMarkReady", {
        state: {
          storeCustomerId: storeCustomerId,
          bookingOrderId: bookingOrderId,
        },
      });
    } else if (item.id === 2) {
      navigate("/ViewInvoice", {
        state: {
          bookingOrderId: bookingOrderId,
          storeCustomerId: storeCustomerId,
        },
      });
    } else if (item.id === 3) {
      navigate("/ViewQrCode", {
        state: {
          bookingOrderId: bookingOrderId,
          storeCustomerId: storeCustomerId,
        },
      });
    } else {
      navigate("/");
    }
  };

  const onSelectInProcessOrder = (item) => {
    if (item.id === 1) {
      navigate("/PartialMarkReady", {
        state: {
          storeCustomerId: storeCustomerId,
          bookingOrderId: bookingOrderId,
        },
      });
    } else if (item.id === 2) {
      navigate("/DeliverOrder", {
        state: {
          storeCustomerId: storeCustomerId,
          bookingOrderId: bookingOrderId,
          customerOrdersData: customerOrdersData,
          selectedUnprocessedQrCodeItems: selectedUnprocessedQrCodeItems,
        },
      });
      // setCancelOrderModal(true);
    } else if (item.id === 3) {
      navigate("/ViewInvoice", {
        state: {
          bookingOrderId: bookingOrderId,
          storeCustomerId: storeCustomerId,
        },
      });
    } else if (item.id === 4) {
      navigate("/ViewQrCode", {
        state: {
          bookingOrderId: bookingOrderId,
          storeCustomerId: storeCustomerId,
        },
      });
    } else {
      navigate("/");
    }
  };

  const onSelectCategoryAfterProcessOrder = (item) => {
    if (item.id === 1) {
      navigate("/DeliverOrder", {
        state: {
          storeCustomerId: storeCustomerId,
          bookingOrderId: bookingOrderId,
          customerOrdersData: customerOrdersData,
          selectedUnprocessedQrCodeItems: selectedUnprocessedQrCodeItems,
        },
      });
    } else if (item.id === 2) {
      navigate("/ViewInvoice", {
        state: {
          bookingOrderId: bookingOrderId,
          storeCustomerId: storeCustomerId,
        },
      });
    } else if (item.id === 3) {
      navigate("/ViewQrCode", {
        state: {
          bookingOrderId: bookingOrderId,
          storeCustomerId: storeCustomerId,
        },
      });
    } else {
      navigate("/");
    }
  };

  const onSelectCategoryOnDoneOrder = (item) => {
    if (item.id === 1) {
      navigate("/ViewInvoice", {
        state: {
          bookingOrderId: bookingOrderId,
          storeCustomerId: storeCustomerId,
        },
      });
    } else if (item.id === 2) {
      navigate("/ViewQrCode", {
        state: {
          bookingOrderId: bookingOrderId,
          storeCustomerId: storeCustomerId,
        },
      });
    } else {
      navigate("/");
    }
  };

  const onSelectCategoryOnOFDBAOrder = (item) => {
    if (item.id === 1) {
      setDeliverOrderWithAuthCodeModalVisible(true);
    } else if (item.id === 2) {
      navigate("/ViewInvoice", {
        state: {
          bookingOrderId: bookingOrderId,
          storeCustomerId: storeCustomerId,
        },
      });
    } else if (item.id === 3) {
      navigate("/ViewQrCode", {
        state: {
          bookingOrderId: bookingOrderId,
          storeCustomerId: storeCustomerId,
        },
      });
    } else {
      navigate("/");
    }
  };

  const onSelectCategoryOnDeliveredOrder = (item) => {
    if (item.id === 1) {

      if (customerOrdersData.appliedSubscriptionDiscount &&
        customerOrdersData.subscriptionDiscount > 0 &&
        customerOrdersData.paidAmount > 0 && customerOrdersData.balanceAmount > 0) {
        setCollectPaymentSubscriptionClosedModalVisible(true);
      } else {
        setCollectPaymentModalVisible(true);
      }


    } else if (item.id === 2) {
      navigate("/ViewInvoice", {
        state: {
          bookingOrderId: bookingOrderId,
          storeCustomerId: storeCustomerId,
        },
      });
    } else if (item.id === 3) {
      navigate("/ViewQrCode", {
        state: {
          bookingOrderId: bookingOrderId,
          storeCustomerId: storeCustomerId,
        },
      });
    } else {
      navigate("/");
    }
  };

  const [editModeLoading, setEditModeLoading] = useState(false);

  const handleOrderEditMode = (value) => {
    if (editModeLoading) return; // guard against re-entry while a request is in flight

    const orderEditType = value ? 'on' : 'off';
    setEditModeLoading(true);

    OrderEditWithType(storeId, storeCustomerId, customerOrdersData?.id, orderEditType)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          if (Res.status) {
            setOrderEditMode(value);
            fetchCustomerSingleOrder();
            fetchStoreCustomerGetInfo();
            fetchGetDeliveryQrCode({ status: ["UNPROCESSED"] });
            fetchLocalStoreDefaultPrice();
          }
        }
      })
      .catch((err) => console.error("Error:", err))
      .finally(() => setEditModeLoading(false));
  };

  const receiveDataFromGarmentInfoCard = ({ info }) => {
    if (info) {
      fetchCustomerSingleOrder();
      fetchStoreCustomerGetInfo();
      const data = {
        // status: ['OUT_FOR_DELIVERY'], // no need to do this
        status: ["UNPROCESSED"],
      };
      fetchGetDeliveryQrCode(data);
      fetchLocalStoreDefaultPrice();
    }
  };

  const handleNotificationModal = (messageType) => {
    setOrderNotificationVisible(true);
    setOrderNotificationMessageType(messageType);
  };

  const handleDirectDelivery = () => {
    const data = {
      status: ["IN_PROCESS"],
    };
    postQrCodeByStatus(storeCustomerId, storeId, bookingOrderId, data)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          const qrCodeArray = Res.map((item) => item.qrcode);
          const bulkQrData = {
            qrcodeList: qrCodeArray,
            status: "READY_TO_DELIVER_BY_STORE",
            remark: "ready now",
          };

          postBulkQrCode(storeCustomerId, storeId, bookingOrderId, bulkQrData)
            .then((response) => {
              if (!response.data.error) {
                const Res = response.data;

                setModalVisible(true);
                setModalStatusText(Res.status === true ? "success" : false);
                if (Res.status) {
                  const timer = setTimeout(() => {
                    navigate("/PaymentCollection", {
                      state: {
                        storeCustomerId: storeCustomerId,
                        bookingOrderId: bookingOrderId,
                      },
                    });
                  }, 1200);
                  return () => clearTimeout(timer); // Clear the timer if the component unmounts or modalVisible changes
                }
              }
            })
            .catch((err) => {
              console.error("Error:", err);
            });
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };

  const val1 = customerOrdersData?.documentScheduled;

  const renderCardOnUserRider = () => {
    return CardDataUserRiderOrder?.map((item, index) => (
      <div
        className="cursor-pointer"
        onClick={() => onUserRiderSelection(item)}
      >
        <div className="flex justify-content-center align-items-center">
          <div
            className="flex justify-content-center align-items-center border-1"
            style={{
              height: height < 600 ? 51 : 61,
              width: height < 600 ? 51 : 61,
              backgroundColor: item.fillColor,
              borderRadius: 50,
              borderColor: item.borderColor,
            }}
          >
            <img
              src={item.img}
              style={{
                width: height < 600 ? 25 : 30,
                height: height < 600 ? 25 : 30,
                alignSelf: "center",
              }}
            />
          </div>
        </div>

        <div className="py-2">
          <p
            className="text-xl font-normal capitalize"
            style={
              index === 0 && processOrderActive === item.id
                ? { color: "#008EFF" }
                : { color: "#75879B" }
            }
          >
            {item.name}
          </p>
        </div>
      </div>
    ));
  };

  const renderCardBeforeProcessOrder = () => {
    return CardDataBeforeProcessOrder?.map((item, index) => {
      // const showLock = item.id === 2 && !enableCancelOrder;
      const showLock =
        (item.id === 3 && val1) || // id 3 → only documentScheduled
        (item.id === 4 && val1) || // id 4 → only documentScheduled
        (item.id === 2 && !enableCancelOrder);

      return (
        <div
          className="cursor-pointer"
          onClick={() => {
            if (!showLock) {
              onSelectCategoryBeforeProcessOrder(item);
            }
          }}
        >
          <div className="flex justify-content-center align-items-center">
            <div
              className="flex justify-content-center align-items-center border-1"
              style={{
                height: height < 600 ? 51 : 61,
                width: height < 600 ? 51 : 61,
                backgroundColor: item.fillColor,
                borderRadius: 50,
                borderColor: item.borderColor,
              }}
            >
              {showLock ? (
                <img
                  src={"Icons/lock.png"}
                  style={{
                    width: height < 600 ? 45 : 50,
                    height: height < 600 ? 45 : 50,
                    backgroundColor: "transparent",
                  }}
                />
              ) : (
                <img
                  src={item.img}
                  style={{
                    width: height < 600 ? 25 : 30,
                    height: height < 600 ? 25 : 30,
                    alignSelf: "center",
                  }}
                />
              )}
            </div>
          </div>

          <div className="py-2">
            <p
              className="text-xl font-normal capitalize"
              style={
                index === 0 && processOrderActive === item.id
                  ? { color: "#008EFF" }
                  : { color: "#75879B" }
              }
            >
              {item.name}
            </p>
          </div>
        </div>
      );
    });
  };

  const renderCardOnOnNoOrderProcess = () => {
    return CardDataOnNoOrderProcess?.map((item, index) => {
      const showLock =
        (item.id === 3 && val1) || // id 3 → only documentScheduled
        (item.id === 2 && val1)

      return (
        <div
          className="cursor-pointer"
          onClick={() => {
            if (!showLock) { onSelectCategoryOnNoOrderProcess(item) }
          }}
        >
          <div className="flex justify-content-center align-items-center">
            <div
              className="flex justify-content-center align-items-center border-1"
              style={{
                height: height < 600 ? 51 : 61,
                width: height < 600 ? 51 : 61,
                backgroundColor: item.fillColor,
                borderRadius: 50,
                borderColor: item.borderColor,
              }}
            >
              {showLock ? (
                <img
                  src={"Icons/lock.png"}
                  style={{
                    width: height < 600 ? 45 : 50,
                    height: height < 600 ? 45 : 50,
                    backgroundColor: "transparent",
                  }}
                />
              ) : (
                <img
                  src={item.img}
                  style={{
                    width: height < 600 ? 25 : 30,
                    height: height < 600 ? 25 : 30,
                    alignSelf: "center",
                  }}
                />
              )}
            </div>
          </div>

          <div className="py-2">
            <p
              className="text-xl font-normal capitalize"
              style={
                index === 0 && processOrderActive === item.id
                  ? { color: "#008EFF" }
                  : { color: "#75879B" }
              }
            >
              {item.name}
            </p>
          </div>
        </div>
      );
    });
  };
  const renderCardOnInprocessOrder = () => {
    return CardDataAfterOneGarmentProcessInOrder?.map((item, index) => {
      const showLock =
        (item.id === 3 && val1) || // id 3 → only documentScheduled
        (item.id === 2 && val1)

      return (
        <div
          className="cursor-pointer"
          onClick={() => { if (!showLock) { onSelectInProcessOrder(item) } }}
        >
          <div className="flex justify-content-center align-items-center">
            <div
              className="flex justify-content-center align-items-center border-1"
              style={{
                height: height < 600 ? 51 : 61,
                width: height < 600 ? 51 : 61,
                backgroundColor: item.fillColor,
                borderRadius: 50,
                borderColor: item.borderColor,
              }}
            >
              {showLock ? (
                <img
                  src={"Icons/lock.png"}
                  style={{
                    width: height < 600 ? 45 : 50,
                    height: height < 600 ? 45 : 50,
                    backgroundColor: "transparent",
                  }}
                />
              ) : (
                <img
                  src={item.img}
                  style={{
                    width: height < 600 ? 25 : 30,
                    height: height < 600 ? 25 : 30,
                    alignSelf: "center",
                  }}
                />
              )}
            </div>
          </div>

          <div className="py-2">
            <p
              className="text-xl font-normal capitalize"
              style={
                index === 0 && processOrderActive === item.id
                  ? { color: "#008EFF" }
                  : { color: "#75879B" }
              }
            >
              {item.name}
            </p>
          </div>
        </div>
      );
    });
  };

  const renderCardAfterProcessOrder = () => {
    return CardDataAfterProcessOrder?.map((item, index) => {
      const showLock =
        (item.id === 3 && val1) || // id 3 → only documentScheduled
        (item.id === 2 && val1);

      return (
        <div
          className="cursor-pointer"
          onClick={() => {
            if (!showLock) {
              onSelectCategoryAfterProcessOrder(item);
            }
          }}
        >
          <div className="flex justify-content-center align-items-center">
            <div
              className="flex justify-content-center align-items-center border-1"
              style={{
                height: height < 600 ? 51 : 61,
                width: height < 600 ? 51 : 61,
                backgroundColor: item.fillColor,
                borderRadius: 50,
                borderColor: item.borderColor,
              }}
            >
              {showLock ? (
                <img
                  src={"Icons/lock.png"}
                  style={{
                    width: height < 600 ? 45 : 50,
                    height: height < 600 ? 45 : 50,
                    backgroundColor: "transparent",
                  }}
                />
              ) : (
                <img
                  src={item.img}
                  style={{
                    width: height < 600 ? 25 : 30,
                    height: height < 600 ? 25 : 30,
                    alignSelf: "center",
                  }}
                />
              )}
            </div>
          </div>

          <div className="py-2">
            <p
              className="text-xl font-normal capitalize"
              style={
                index === 0 && processOrderActive === item.id
                  ? { color: "#008EFF" }
                  : { color: "#75879B" }
              }
            >
              {item.name}
            </p>
          </div>
        </div>
      );
    });
  };

  const renderCardOnInWarehouseOrder = () => {
    return CardDataOnDoneOrder?.map((item, index) => {
      const showLock =
        (item.id === 2 && val1) || // id 3 → only documentScheduled
        (item.id === 1 && val1)

      return (
        <div
          className="cursor-pointer"
          onClick={() => {
            if (!showLock) {
              onSelectCategoryOnDoneOrder(item);
            }
          }}
        >
          <div className="flex justify-content-center align-items-center">
            <div
              className="flex justify-content-center align-items-center border-1"
              style={{
                height: height < 600 ? 51 : 61,
                width: height < 600 ? 51 : 61,
                backgroundColor: item.fillColor,
                borderRadius: 50,
                borderColor: item.borderColor,
              }}
            >
              {showLock ? (
                <img
                  src={"Icons/lock.png"}
                  style={{
                    width: height < 600 ? 45 : 50,
                    height: height < 600 ? 45 : 50,
                    backgroundColor: "transparent",
                  }}
                />
              ) : (
                <img
                  src={item.img}
                  style={{
                    width: height < 600 ? 25 : 30,
                    height: height < 600 ? 25 : 30,
                    alignSelf: "center",
                  }}
                />
              )}
            </div>
          </div>

          <div className="py-2">
            <p
              className="text-xl font-normal capitalize"
              style={
                index === 0 && processOrderActive === item.id
                  ? { color: "#008EFF" }
                  : { color: "#75879B" }
              }
            >
              {item.name}
            </p>
          </div>
        </div>
      )
    });
  };

  const renderCardOnDoneOrder = () => {
    return CardDataOnDoneOrder?.map((item, index) => {
      const showLock = item.id === 2 || (item.id === 1 && val1);
      return (
        <div
          className="cursor-pointer"
          onClick={() => {
            {
              !showLock && onSelectCategoryOnDoneOrder(item);
            }
          }}
        >
          <div className="flex justify-content-center align-items-center">
            <div
              className="flex justify-content-center align-items-center border-1"
              style={{
                height: height < 600 ? 51 : 61,
                width: height < 600 ? 51 : 61,
                backgroundColor: item.fillColor,
                borderRadius: 50,
                borderColor: item.borderColor,
              }}
            >
              {showLock ? (
                <img
                  src={"Icons/lock.png"}
                  style={{
                    width: height < 600 ? 45 : 50,
                    height: height < 600 ? 45 : 50,
                    backgroundColor: "transparent",
                  }}
                />
              ) : (
                <img
                  src={item.img}
                  style={{
                    width: height < 600 ? 25 : 30,
                    height: height < 600 ? 25 : 30,
                    alignSelf: "center",
                  }}
                />
              )}
            </div>
          </div>

          <div className="py-2">
            <p
              className="text-xl font-normal capitalize"
              style={
                index === 0 && processOrderActive === item.id
                  ? { color: "#008EFF" }
                  : { color: "#75879B" }
              }
            >
              {item.name}
            </p>
          </div>
        </div>
      );
    });
  };

  const renderCardOnDeliveredOrder = () => {
    return CardDataOnDeliveredOrder?.map((item, index) => {
      const showLock = item.id === 3 || (item.id === 2 && val1);
      // const showLock2 = userRole === "BY_STORE" &&
      // item.id === 1 &&
      // customerOrdersData.appliedSubscriptionDiscount &&
      // customerOrdersData.subscriptionDiscount > 0;

      const isLocked = showLock;
      // || showLock2;

      return (
        <div
          className="cursor-pointer"
          onClick={() => {
            if (!isLocked) {
              onSelectCategoryOnDeliveredOrder(item);
            }
          }}
        >
          <div className="flex justify-content-center align-items-center">
            <div
              className="flex justify-content-center align-items-center border-1"
              style={{
                height: height < 600 ? 51 : 61,
                width: height < 600 ? 51 : 61,
                backgroundColor: item.fillColor,
                borderRadius: 50,
                borderColor: item.borderColor,
              }}
            >
              {isLocked ? (
                <img
                  src={"Icons/lock.png"}
                  style={{
                    width: height < 600 ? 45 : 50,
                    height: height < 600 ? 45 : 50,
                    backgroundColor: "transparent",
                  }}
                />
              ) : (
                <img
                  src={item.img}
                  style={{
                    width: height < 600 ? 25 : 30,
                    height: height < 600 ? 25 : 30,
                    alignSelf: "center",
                  }}
                />
              )}
            </div>
          </div>

          <div className="py-2">
            <p
              className="text-xl font-normal capitalize"
              style={
                index === 0 && processOrderActive === item.id
                  ? { color: "#008EFF" }
                  : { color: "#75879B" }
              }
            >
              {item.name}
            </p>
          </div>
        </div>
      );
    });
  };

  const renderCardAfterCancelOrder = () => {
    return CardDataAfterCancelOrder?.map((item, index) => (
      <div>
        <div className="flex justify-content-center align-items-center">
          <div
            className="flex justify-content-center align-items-center border-1"
            style={{
              height: height < 600 ? 51 : 61,
              width: height < 600 ? 51 : 61,
              backgroundColor: item.fillColor,
              borderRadius: 50,
              borderColor: item.borderColor,
            }}
          >
            <img
              src={item.img}
              style={{
                width: height < 600 ? 25 : 30,
                height: height < 600 ? 25 : 30,
                alignSelf: "center",
              }}
            />
          </div>
        </div>

        <div className="py-2">
          <p
            className="text-xl font-normal capitalize"
            style={
              index === 0 && processOrderActive === item.id
                ? { color: "#008EFF" }
                : { color: "#75879B" }
            }
          >
            {item.name}
          </p>
        </div>
      </div>
    ));
  };

  const renderCardOnOFDBAOrder = () => {
    return CardDataUserRiderOFDBAOrder?.map((item, index) => (
      <div
        className="cursor-pointer"
        onClick={() => onSelectCategoryOnOFDBAOrder(item)}
      >
        <div className="flex justify-content-center align-items-center">
          <div
            className="flex justify-content-center align-items-center border-1"
            style={{
              height: height < 600 ? 51 : 61,
              width: height < 600 ? 51 : 61,
              backgroundColor: item.fillColor,
              borderRadius: 50,
              borderColor: item.borderColor,
            }}
          >
            <img
              src={item.img}
              style={{
                width: height < 600 ? 25 : 30,
                height: height < 600 ? 25 : 30,
                alignSelf: "center",
              }}
            />
          </div>
        </div>

        <div className="py-2">
          <p
            className="text-xl font-normal capitalize"
            style={
              index === 0 && processOrderActive === item.id
                ? { color: "#008EFF" }
                : { color: "#75879B" }
            }
          >
            {item.name}
          </p>
        </div>
      </div>
    ));
  };

  return (
    <div className="flex-1">
      <div
        className="h-3rem surface-0 sticky z-2 top-0 flex justify-content-center align-items-center"
        style={{
          "--surface-0": "#fff",
        }}
      >
        <div className="flex-1 flex ml-3 mr-3">
          <div className="flex-1 flex ">
            <div className="ml-3 flex justify-content-center align-items-center">
              <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                <i
                  className="pi pi-angle-left cursor-pointer"
                  onClick={() => handleBackButton()}
                  style={{ fontSize: "27px", cursor: "pointer", color: "#000" }}
                ></i>
              </div>
            </div>
            <div className="flex-1 ml-5 flex justify-content-start align-items-center">
              <p className=" text-2xl font-bold capitalize">Order Info</p>
            </div>
          </div>

          {b2BChallanOrder && <div
            className="flex justify-content-center align-items-center cursor-pointer"
            onClick={() => {
              navigate("/B2BDeliveredChallanViewList", {
                state: {
                  storeCustomerId: storeCustomerId,
                  orderId: customerOrdersData,

                },
              })
            }}
          >
            <div className="px-1 py-1 cursor-pointer">
              <div
                className="px-3 py-1 cursor-pointer"
                style={{
                  backgroundColor: "#1752AA",
                  borderRadius: 5,
                  marginRight: 20,
                }}
              >
                <p className=" text-lg text-white font-medium capitalize">
                  View Challan
                </p>
              </div>
            </div>
          </div>}
          <div
            className="flex justify-content-center align-items-center cursor-pointer"
            onClick={() => navigate("/")}
          >
            <div
              className="px-3 py-1 cursor-pointer"
              style={{
                marginRight: 20,
              }}
            >
              <img
                src={"Laundy_App_Icons_Gifs/Home_Page_Menu_Bar/home-button.png"}
                style={{
                  width: 40,
                }}
              />
            </div>
          </div>
          {userRole === "BY_STORE" && enabledRfIdModal && (
            <div className="mx-4 cursor-pointer">
              <div
                className="relative"
                onClick={() =>
                  navigate("/CheckGarmentRFID", {
                    state: {
                      storeCustomerId: storeCustomerId,
                      bookingOrderId: bookingOrderId,
                      navThrough: "customerOrder",
                    },
                  })
                }
              >
                <div
                  style={{
                    position: "absolute",
                    right: 0,
                    top: 10,
                  }}
                >
                  <img
                    src={"Laundy_App_Icons_Gifs/Other_Icons/View_QR_Code.png"}
                    style={{
                      width: 30,
                      height: 30,
                      backgroundColor: "transparent",
                    }}
                    alt="qrcode"
                  />
                </div>
              </div>
            </div>
          )}
          {enabledByPassOrderProcess &&
            userRole === "BY_STORE" &&
            customerOrdersData.status === "BOOKED" && (
              <div
                className="flex justify-content-center align-items-center cursor-pointer"
                onClick={() => handleDirectDelivery()}
              >
                <div className="px-1 py-1 cursor-pointer">
                  <div
                    className="px-3 py-1 cursor-pointer"
                    style={{
                      backgroundColor: "#1752AA",
                      borderRadius: 5,
                      marginRight: 20,
                    }}
                  >
                    <p className=" text-lg text-white font-medium capitalize">
                      Direct Delivery
                    </p>
                  </div>
                </div>
              </div>
            )}
          {(customerOrdersData.editBy > 0 ||
            customerOrdersData.editBy !== null) && (
              <div
                className="flex justify-content-center align-items-center cursor-pointer"
                onClick={() => setOrderInfoEditByProfileVisible(true)}
              >
                <div
                  className="px-3 py-1 cursor-pointer"
                  style={{
                    backgroundColor: "green",
                    borderRadius: 5,
                    marginRight: 20,
                  }}
                >
                  <p className=" text-lg text-white font-medium capitalize">
                    Last Edited By
                  </p>
                </div>
              </div>
            )}
          <div
            className="flex justify-content-center align-items-center cursor-pointer"
            onClick={() => setVisible(true)}
          >
            <i
              className="pi pi-bars"
              style={{ fontSize: "27px", marginRight: 30, color: "#000" }}
            ></i>
          </div>
        </div>
      </div>

      <div
        className="border-none surface-0 flex-1  mx-4 py-1 mb-3"
        style={{
          borderRadius: 5,
          backgroundImage:
            "radial-gradient(circle at left top, #1752AA, #2B70D7)",
        }}
      >
        <div className="px-4">
          <div
            className="flex cursor-pointer"
            onClick={() => {
              navigate("/CustomerInfo", {
                state: {
                  storeCustomerId: storeCustomerId,
                },
              });
            }}
          >
            <div className="flex-1 flex justify-content-start align-items-center">
              <p className="text-white text-lg font-normal capitalize">
                Customer Name :
              </p>
              <p className="text-white text-xl font-semibold capitalize ml-2">
                {CustomerInformation?.firstName} {CustomerInformation?.lastName}
              </p>
            </div>
            <div className="flex-1 flex justify-content-start align-items-center">
              <p className="text-white text-lg font-normal capitalize ">
                Mobile No. :
              </p>
              <p className="text-white text-xl font-semibold capitalize ml-2">
                {maskMobileNumber(CustomerInformation?.mobile)}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="flex flex-1 justify-content-around align-item-center">
        {userRole === "BY_RIDER" &&
          customerOrdersData.status === "BOOKED" &&
          !showCancelOrder &&
          renderCardOnUserRider()}
        {userRole === "BY_STORE" &&
          customerOrdersData.status === "BOOKED" &&
          !showCancelOrder && (
            <>
              {renderCardBeforeProcessOrder()}
              {customerOrdersData.balanceAmount > 0 && (
                <div
                  className="cursor-pointer"
                  onClick={() => {
                    {
                      customerOrdersData.appliedSubscriptionDiscount ===
                        false &&
                        customerOrdersData.subscriptionDiscount === 0 &&
                        setCollectPaymentModalVisible(true);
                    }
                  }}
                >
                  <div className="flex justify-content-center align-items-center">
                    <div
                      className="flex justify-content-center align-items-center border-1"
                      style={{
                        height: height < 600 ? 51 : 61,
                        width: height < 600 ? 51 : 61,
                        backgroundColor: "#FFF9DE",
                        borderRadius: 50,
                        borderColor: "#F5C43A",
                      }}
                    >
                      {customerOrdersData.appliedSubscriptionDiscount &&
                        customerOrdersData.subscriptionDiscount > 0 ? (
                        <img
                          src={"Icons/lock.png"}
                          style={{
                            width: height < 600 ? 45 : 50,
                            height: height < 600 ? 45 : 50,
                            backgroundColor: "transparent",
                          }}
                        />
                      ) : (
                        <img
                          src="Laundy_App_Icons_Gifs/Packages_GIFs/package4.gif"
                          style={{
                            width: height < 600 ? 25 : 30,
                            height: height < 600 ? 25 : 30,
                            alignSelf: "center",
                          }}
                        />
                      )}
                    </div>
                  </div>

                  <div className="py-2">
                    <p
                      className="text-xl font-normal capitalize"
                      style={{ color: "#75879B" }}
                    >
                      Collect Payment
                    </p>
                  </div>
                </div>
              )}
            </>
          )}
        {userRole === "BY_STORE" &&
          customerOrdersData.status === "PROCESSED" && (
            <>
              {renderCardAfterProcessOrder()}
              {customerOrdersData.balanceAmount > 0 && (
                <div
                  className="cursor-pointer"
                  onClick={() => {
                    {
                      customerOrdersData.appliedSubscriptionDiscount ===
                        false &&
                        customerOrdersData.subscriptionDiscount === 0 &&
                        setCollectPaymentModalVisible(true);
                    }
                  }}
                >
                  <div className="flex justify-content-center align-items-center">
                    <div
                      className="flex justify-content-center align-items-center border-1"
                      style={{
                        height: height < 600 ? 51 : 61,
                        width: height < 600 ? 51 : 61,
                        backgroundColor: "#FFF9DE",
                        borderRadius: 50,
                        borderColor: "#F5C43A",
                      }}
                    >
                      {customerOrdersData.appliedSubscriptionDiscount &&
                        customerOrdersData.subscriptionDiscount > 0 ? (
                        <img
                          src={"Icons/lock.png"}
                          style={{
                            width: height < 600 ? 45 : 50,
                            height: height < 600 ? 45 : 50,
                            backgroundColor: "transparent",
                          }}
                        />
                      ) : (
                        <img
                          src="Laundy_App_Icons_Gifs/Packages_GIFs/package4.gif"
                          style={{
                            width: height < 600 ? 25 : 30,
                            height: height < 600 ? 25 : 30,
                            alignSelf: "center",
                          }}
                        />
                      )}
                    </div>
                  </div>

                  <div className="py-2">
                    <p
                      className="text-xl font-normal capitalize"
                      style={{ color: "#75879B" }}
                    >
                      Collect Payment
                    </p>
                  </div>
                </div>
              )}
            </>
          )}
        {customerOrdersData.status === "DONE" && renderCardOnDoneOrder()}
        {userRole === "BY_STORE" &&
          customerOrdersData.status === "INPROCESS" &&
          processGarment && (
            <>
              {renderCardOnInprocessOrder()}

              {customerOrdersData.balanceAmount > 0 && (
                <div
                  className="cursor-pointer"
                  onClick={() => {
                    {
                      customerOrdersData.appliedSubscriptionDiscount ===
                        false &&
                        customerOrdersData.subscriptionDiscount === 0 &&
                        setCollectPaymentModalVisible(true);
                    }
                  }}
                >
                  <div className="flex justify-content-center align-items-center">
                    <div
                      className="flex justify-content-center align-items-center border-1"
                      style={{
                        height: height < 600 ? 51 : 61,
                        width: height < 600 ? 51 : 61,
                        backgroundColor: "#FFF9DE",
                        borderRadius: 50,
                        borderColor: "#F5C43A",
                      }}
                    >
                      {customerOrdersData.appliedSubscriptionDiscount &&
                        customerOrdersData.subscriptionDiscount > 0 ? (
                        <img
                          src={"Icons/lock.png"}
                          style={{
                            width: height < 600 ? 45 : 50,
                            height: height < 600 ? 45 : 50,
                            backgroundColor: "transparent",
                          }}
                        />
                      ) : (
                        <img
                          src="Laundy_App_Icons_Gifs/Packages_GIFs/package4.gif"
                          style={{
                            width: height < 600 ? 25 : 30,
                            height: height < 600 ? 25 : 30,
                            alignSelf: "center",
                          }}
                        />
                      )}
                    </div>
                  </div>

                  <div className="py-2">
                    <p
                      className="text-xl font-normal capitalize"
                      style={{ color: "#75879B" }}
                    >
                      Collect Payment
                    </p>
                  </div>
                </div>
              )}
            </>
          )}
        {userRole === "BY_STORE" &&
          customerOrdersData.status === "INPROCESS" &&
          !processGarment && (
            <>
              {renderCardOnOnNoOrderProcess()}
              {customerOrdersData.balanceAmount > 0 && (
                <div
                  className="cursor-pointer"
                  onClick={() => {
                    {
                      customerOrdersData.appliedSubscriptionDiscount ===
                        false &&
                        customerOrdersData.subscriptionDiscount === 0 &&
                        setCollectPaymentModalVisible(true);
                    }
                  }}
                >
                  <div className="flex justify-content-center align-items-center">
                    <div
                      className="flex justify-content-center align-items-center border-1"
                      style={{
                        height: height < 600 ? 51 : 61,
                        width: height < 600 ? 51 : 61,
                        backgroundColor: "#FFF9DE",
                        borderRadius: 50,
                        borderColor: "#F5C43A",
                      }}
                    >
                      {customerOrdersData.appliedSubscriptionDiscount &&
                        customerOrdersData.subscriptionDiscount > 0 ? (
                        <img
                          src={"Icons/lock.png"}
                          style={{
                            width: height < 600 ? 45 : 50,
                            height: height < 600 ? 45 : 50,
                            backgroundColor: "transparent",
                          }}
                        />
                      ) : (
                        <img
                          src="Laundy_App_Icons_Gifs/Packages_GIFs/package4.gif"
                          style={{
                            width: height < 600 ? 25 : 30,
                            height: height < 600 ? 25 : 30,
                            alignSelf: "center",
                          }}
                        />
                      )}
                    </div>
                  </div>

                  <div className="py-2">
                    <p
                      className="text-xl font-normal capitalize"
                      style={{ color: "#75879B" }}
                    >
                      Collect Payment
                    </p>
                  </div>
                </div>
              )}
            </>
          )}
        {customerOrdersData.status === "IN_WAREHOUSE" && (
          <>
            {hasProcessedGarment && <div
              className="cursor-pointer"
              onClick={() => {
                navigate("/DeliverOrder", {
                  state: {
                    storeCustomerId: storeCustomerId,
                    bookingOrderId: bookingOrderId,
                    customerOrdersData: customerOrdersData,
                    selectedUnprocessedQrCodeItems:
                      selectedUnprocessedQrCodeItems,
                  },
                });
              }}
            >
              <div className="flex justify-content-center align-items-center">
                <div
                  className="flex justify-content-center align-items-center border-1"
                  style={{
                    height: height < 600 ? 51 : 61,
                    width: height < 600 ? 51 : 61,
                    backgroundColor: "#E7F4FF",
                    borderRadius: 50,
                    borderColor: "#3EB3E1",
                  }}
                >
                  <img
                    src="Laundy_App_Icons_Gifs/Other_Icons/Deliver_Order.png"
                    style={{
                      width: height < 600 ? 25 : 30,
                      height: height < 600 ? 25 : 30,
                      alignSelf: "center",
                    }}
                  />
                </div>
              </div>

              <div className="py-2">
                <p
                  className="text-xl font-normal capitalize"
                  style={{ color: "#75879B" }}
                >
                  Deliver Order
                </p>
              </div>
            </div>}
            {customerOrdersData.balanceAmount > 0 && (
              <div
                className="cursor-pointer"
                onClick={() => {
                  {
                    // customerOrdersData.appliedSubscriptionDiscount === false &&
                    //   customerOrdersData.subscriptionDiscount === 0 &&
                    setCollectPaymentModalVisible(true);
                  }
                }}
              >
                <div className="flex justify-content-center align-items-center">
                  <div
                    className="flex justify-content-center align-items-center border-1"
                    style={{
                      height: height < 600 ? 51 : 61,
                      width: height < 600 ? 51 : 61,
                      backgroundColor: "#FFF9DE",
                      borderRadius: 50,
                      borderColor: "#F5C43A",
                    }}
                  >
                    {customerOrdersData.appliedSubscriptionDiscount &&
                      customerOrdersData.subscriptionDiscount > 0 ? (
                      <img
                        src={"Icons/lock.png"}
                        style={{
                          width: height < 600 ? 45 : 50,
                          height: height < 600 ? 45 : 50,
                          backgroundColor: "transparent",
                        }}
                      />
                    ) : (
                      <img
                        src="Laundy_App_Icons_Gifs/Packages_GIFs/package4.gif"
                        style={{
                          width: height < 600 ? 25 : 30,
                          height: height < 600 ? 25 : 30,
                          alignSelf: "center",
                        }}
                      />
                    )}
                  </div>
                </div>

                <div className="py-2">
                  <p
                    className="text-xl font-normal capitalize"
                    style={{ color: "#75879B" }}
                  >
                    Collect Payment
                  </p>
                </div>
              </div>
            )}
            {renderCardOnInWarehouseOrder()}
          </>
        )}{" "}
        {/** open deivery */}
        {userRole === "BY_STORE" &&
          customerOrdersData.status === "OUT_FOR_DELIVERY" &&
          customerOrdersData.balanceAmount === 0 &&
          renderCardOnDoneOrder()}
        {userRole === "BY_STORE" &&
          customerOrdersData.status === "OUT_FOR_DELIVERY" &&
          customerOrdersData.balanceAmount < 0 &&
          renderCardOnDoneOrder()}
        {userRole === "BY_RIDER" &&
          customerOrdersData.status === "OUT_FOR_DELIVERY" &&
          customerOrdersData.balanceAmount === 0 &&
          renderCardOnOFDBAOrder()}
        {userRole === "BY_RIDER" &&
          (customerOrdersData.status === "PROCESSED" ||
            customerOrdersData.status === "INPROCESS") &&
          renderCardOnDoneOrder()}
        {customerOrdersData.status === "DELIVERED"
          ? customerOrdersData.balanceAmount > 0
            ? renderCardOnDeliveredOrder()
            : renderCardOnDoneOrder()
          : ""}
        {!["BOOKED", "PROCESSED", "DONE", "DELIVERED", "CANCEL"].includes(
          customerOrdersData.status
        ) &&
          ["OUT_FOR_DELIVERY"].includes(customerOrdersData.status) &&
          customerOrdersData.balanceAmount > 0 &&
          renderCardOnDeliveredOrder()}
        {customerOrdersData.status === "CANCEL" && renderCardAfterCancelOrder()}
      </div>
      <div className="flex flex-1">
        <div className="flex-1">
          <div
            className="flex-1  surface-0"
            style={{ "--surface-0": "#EAEFF5", position: "relative" }}
          >
            <div className="flex justify-content-between mx-4">
              <div className="py-1">
                <p className=" text-2xl  font-bold ">Order Info</p>
              </div>
            </div>

            <div>
              {!["DONE", "DELIVERED", "CANCEL"].includes(
                customerOrdersData.status
              ) && (
                  <React.Fragment>
                    {selectedUnprocessedQrCodeItems.length > 0 && (
                      <div
                        style={{
                          position: "absolute",
                          right: 250,
                          top: 4,
                        }}
                      >
                        <div
                          className="px-3 py-1 cursor-pointer"
                          onClick={() => setOrderUnprocessedQrCode(true)}
                          style={{
                            backgroundColor: "red",
                            borderRadius: 5,
                          }}
                        >
                          <p className=" text-lg text-white font-medium capitalize">
                            Return UnProcess
                          </p>
                        </div>
                      </div>
                    )}
                  </React.Fragment>
                )}

              {enabledOrderBulkEdit && <React.Fragment>

                {/*<div
                  style={{
                    position: "absolute",
                    right: 80,
                    top: 4,
                  }}
                >
                  <div
                    className="px-3 py-1 cursor-pointer"
                    onClick={() => handleOrderEditMode(!orderEditMode)}
                    style={{
                      backgroundColor: !orderEditMode ? "green" : "red",
                      borderRadius: 5,
                    }}
                  >
                    <p className=" text-lg text-white font-medium capitalize">
                      {!orderEditMode ? "Enable " : "Disable "} Edit Mode
                    </p>
                  </div>
                </div>*/}
                <div
                  style={{
                    position: "absolute",
                    right: 60,
                    top: 2,
                  }}
                >
                  <div style={{  display: "flex", alignItems: "center", justifyContent: "center", }}>
                    <EditModePill editing={orderEditMode} setEditing={handleOrderEditMode} loading={editModeLoading} />
                </div>
                </div>
              </React.Fragment>}
              {!["OUT_FOR_DELIVERY", "CANCEL"].includes(
                customerOrdersData.status
              ) && (
                  <div
                    style={{
                      position: "absolute",
                      right: 30,
                      top: 9,
                    }}
                  >
                    {(userRole === "BY_STORE" && orderEditByStore) ||
                      (userRole === "BY_RIDER" && orderEditByRider) ? (
                      <div>
                        <div onClick={() => setOrderInfoEditVisible(true)}>
                          <i
                            className="pi pi-pencil"
                            style={{
                              fontSize: "20px",
                              cursor: "pointer",
                              color: "#2B70D7",
                            }}
                          ></i>
                        </div>
                      </div>
                    ) : (
                      <div>
                        <div>
                          <i
                            className="pi pi-pencil"
                            style={{
                              fontSize: "20px",
                              cursor: "pointer",
                              color: "#2B70D7",
                            }}
                          ></i>
                        </div>
                        <div
                          style={{
                            position: "absolute",
                            right: 0,
                            top: 0,
                          }}
                        >
                          <img
                            src={"Icons/lock.png"}
                            style={{
                              width: 18,
                              height: 18,
                              backgroundColor: "transparent",
                            }}
                          />
                        </div>
                      </div>
                    )}
                  </div>
                )}
            </div>
          </div>
          <OrderInfoCard
            customerOrdersData={customerOrdersData}
            storeCustomerId={storeCustomerId}
            bookingOrderId={bookingOrderId}
            userRole={userRole}
            storeId={storeId}
            enabledChargeDiscountByService={enabledChargeDiscountByService}
            enabledCustomDiscountCharge={enabledCustomDiscountCharge}
            storeUserId={storeUserId}
            brandId={brandId}
            enabledCreatePaymentLink={enabledCreatePaymentLink}
            updateOrderGarmentInfoPage={receiveDataFromGarmentInfoCard}
            b2BChallanOrder={b2BChallanOrder}
            enabledAmountRoundOff={enabledAmountRoundOff}
          />

          {/** Payment Info */}
          {orderPaymentDetailsData?.length > 0 && (
            <PaymentInfoCard
              orderPaymentDetailsData={orderPaymentDetailsData}
              storeCustomerId={storeCustomerId}
              storeId={storeId}
              bookingOrderId={bookingOrderId}
              sendDataToOrderGarmentInfo={receiveDataFromGarmentInfoCard}
              balanceAmount={orderInfoDetailsBalanceAmount.balanceAmount}
              customerOrdersData={customerOrdersData}
              enableUserAccountDeliveryDiscount={
                enableUserAccountDeliveryDiscount
              }
              storeUserId={storeUserId}
              userRole={userRole}
              enabledBackDate={enabledBackDate}
              enabledEditPayment={enabledEditPayment}
              brandId={brandId}
              enabledAmountRoundOff={enabledAmountRoundOff}
            />
          )}
          {/** Package Info */}
          {orderPackageData?.length > 0 && (
            <PackageInfoCard
              orderPackageData={orderPackageData}
              storeCustomerId={storeCustomerId}
              storeId={storeId}
              bookingOrderId={bookingOrderId}
              sendDataToOrderGarmentInfo={receiveDataFromGarmentInfoCard}
              userRole={userRole}
              orderEditByStore={orderEditByStore}
              orderEditByRider={orderEditByRider}
              customerOrdersData={customerOrdersData}
              offerPriceEnabled={offerPriceEnabled}
            />
          )}
        </div>
        <div className="flex-1">
          <div
            className="flex-1  surface-0 mb-3"
            style={{ "--surface-0": "#EAEFF5" }}
          >
            <div className="flex justify-content-between ml-4">
              <div className="py-1 flex gap-2">
                <p className=" text-2xl  font-bold ">{selectedInfoType.code}</p>
                <div
                  onClick={(e) => op.current.toggle(e)}
                  className="flex justify-content-center align-items-center"
                >
                  <i
                    className={"pi pi-caret-down"}
                    style={{
                      fontSize: "20px",
                      cursor: "pointer",
                      color: "#2B70D7",
                    }}
                  ></i>
                </div>
              </div>

              <OverlayPanel ref={op}>
                <div className="flex-row justify-content-between">
                  <ListBox
                    value={selectedInfoType}
                    onChange={(e) => {
                      setSelectedInfoType(e.value);
                      op.current.hide();
                    }}
                    options={InfoType}
                    optionLabel="name"
                    className="w-full md:w-14rem"
                  />
                </div>
              </OverlayPanel>

              <div className="flex justify-content-center align-items-center">
                <div className="mr-4 cursor-pointer">
                  {enabledGarmentInspection && (
                    <div
                      className="relative"
                      onClick={() =>
                        navigate("/GarmentQrCodeList", {
                          state: {
                            mobileNumber: CustomerInformation.mobile,
                            customerFirstName: CustomerInformation.firstName,
                            customerLastName: CustomerInformation.lastName,
                            storeCustomerId: storeCustomerId,
                            bookingOrderId: bookingOrderId,
                            invoiceNo: customerOrdersData.invoiceNo,
                            orderNo: customerOrdersData.orderNo,
                          },
                        })
                      }
                    >
                      <div
                        style={{
                          position: "absolute",
                          right: 2,
                          top: -12,
                        }}
                      >
                        <i
                          className="pi pi-image"
                          style={{
                            fontSize: "20px",
                            cursor: "pointer",
                            color: "#2B70D7",
                          }}
                        ></i>
                      </div>
                    </div>
                  )}
                </div>
                {userRole === "BY_STORE" && enabledRfIdModal && (
                  <div className="mx-4 cursor-pointer">
                    <div
                      className="relative"
                      onClick={() =>
                        navigate("/GarmentRFIDList", {
                          state: {
                            mobileNumber: CustomerInformation.mobile,
                            customerFirstName: CustomerInformation.firstName,
                            customerLastName: CustomerInformation.lastName,
                            storeCustomerId: storeCustomerId,
                            bookingOrderId: bookingOrderId,
                            invoiceNo: customerOrdersData.invoiceNo,
                            orderNo: customerOrdersData.orderNo,
                          },
                        })
                      }
                    >
                      <div
                        style={{
                          position: "absolute",
                          right: 2,
                          top: -12,
                        }}
                      >
                        <img
                          src={
                            "Laundy_App_Icons_Gifs/Other_Icons/View_QR_Code.png"
                          }
                          style={{
                            width: 18,
                            height: 18,
                            backgroundColor: "transparent",
                          }}
                          alt="qrcode"
                        />
                      </div>
                    </div>
                  </div>
                )}
                {customerOrdersData.status === "BOOKED" && (
                  <div className="mr-4 cursor-pointer">
                    <div
                      onClick={() =>
                        navigate("/GeneralBookingSelection", {
                          state: {
                            priceId:
                              customerOrdersData.orderPackage.length > 0
                                ? storeDefaultPrice.id
                                : customerOrdersData?.selectedPriceId
                                  ? customerOrdersData?.selectedPriceId
                                  : storeDefaultPrice.id,
                            BookingType: "GeneralBooking",
                            storeCustomerId: storeCustomerId,
                            bookingOrderId: bookingOrderId,
                          },
                        })
                      }
                    >
                      <img
                        src={"Laundy_App_Icons_Gifs/Home_Page_Menu_Bar/Add.png"}
                        style={{
                          width: 25,
                          height: 25,
                        }}
                      />
                    </div>
                  </div>
                )}

                {!["DONE", "DELIVERED", "CANCEL"].includes(
                  customerOrdersData.status
                ) && (
                    <div className="mr-4">
                      {(userRole === "BY_STORE" && orderEditByStore) ||
                        (userRole === "BY_RIDER" && orderEditByRider) ? (
                        <div>
                          <div
                            onClick={() =>
                              navigate("/GarmentEdit", {
                                state: {
                                  storeCustomerId: storeCustomerId,
                                  bookingOrderId: bookingOrderId,
                                  storeId: storeId,
                                },
                              })
                            }
                          >
                            <i
                              className="pi pi-pencil"
                              style={{
                                fontSize: "20px",
                                cursor: "pointer",
                                color: "#2B70D7",
                              }}
                            ></i>
                          </div>
                        </div>
                      ) : (
                        <div style={{ position: "relative" }}>
                          <div>
                            <i
                              className="pi pi-pencil"
                              style={{
                                fontSize: "20px",
                                cursor: "pointer",
                                color: "#2B70D7",
                              }}
                            ></i>
                          </div>
                          <div
                            style={{
                              position: "absolute",
                              right: 0,
                              top: 0,
                            }}
                          >
                            <img
                              src={"Icons/lock.png"}
                              style={{
                                width: 18,
                                height: 18,
                                backgroundColor: "transparent",
                              }}
                            />
                          </div>
                        </div>
                      )}
                    </div>
                  )}
              </div>
            </div>
          </div>
          {selectedInfoType.code === "Garment Info" ? (
            <GarmentInfoCard
              orderItemData={orderItemData}
              storeCustomerId={storeCustomerId}
              storeId={storeId}
              bookingOrderId={bookingOrderId}
              brandId={brandId}
              priceId={storeDefaultPrice.id}
              sendDataToOrderGarmentInfo={receiveDataFromGarmentInfoCard}
              offerDiscountByStore={offerDiscountByStore}
              offerDiscountByRider={offerDiscountByRider}
              userRole={userRole}
              offerPriceEnabled={offerPriceEnabled}
              garmentMaxProcessCount={garmentMaxProcessCount}
              garmentServiceIcons={garmentCategoryServiceIconsResData?.iconMap}
              orderEditByStore={orderEditByStore}
              enableDeleteItem={true}
              b2BChallanOrder={b2BChallanOrder}
              enabledAmountRoundOff={enabledAmountRoundOff}
            />
          ) : (
            <div>
              {Object.keys(orderItemGarmentServiceInfoData).map((service) => (
                <div>
                  <div className="ml-2">
                    {/* <p className="text-lg font-normal" style={{color:"red"}}>{service}</p> */}
                    <div className="flex justify-content-start align-items-center cursor-pointer">
                      <Button
                        label={service}
                        className=" text-md  border-round-lg p-1 cursor-pointer"
                        style={{
                          color: "#fff",
                          backgroundColor: "red",
                          borderColor: "red",
                        }}
                      ></Button>
                    </div>
                  </div>
                  <GarmentInfoCard
                    orderItemData={orderItemGarmentServiceInfoData[service]} // Pass the service array
                    storeCustomerId={storeCustomerId}
                    storeId={storeId}
                    bookingOrderId={bookingOrderId}
                    brandId={brandId}
                    priceId={storeDefaultPrice.id}
                    sendDataToOrderGarmentInfo={receiveDataFromGarmentInfoCard}
                    offerDiscountByStore={offerDiscountByStore}
                    offerDiscountByRider={offerDiscountByRider}
                    userRole={userRole}
                    garmentMaxProcessCount={garmentMaxProcessCount}
                    garmentServiceIcons={
                      garmentCategoryServiceIconsResData?.iconMap
                    }
                    orderEditByStore={orderEditByStore}
                    enableDeleteItem={false}
                    b2BChallanOrder={b2BChallanOrder}
                    enabledAmountRoundOff={enabledAmountRoundOff}
                  />
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
      <div>
        {(customerOrdersData.editBy > 0 ||
          customerOrdersData.editBy !== null) && (
            <OrderInfoEditByProfile
              setOrderInfoEditByProfileVisible={setOrderInfoEditByProfileVisible}
              orderInfoEditByProfileVisible={orderInfoEditByProfileVisible}
              editBy={customerOrdersData?.editBy}
            />
          )}
        <OrderInfoEdit
          setOrderInfoEditVisible={setOrderInfoEditVisible}
          orderInfoEditVisible={orderInfoEditVisible}
          customerOrdersData={customerOrdersData}
          storeId={storeId}
          storeUserId={storeUserId}
          storeCustomerId={storeCustomerId}
          processTime={processTime}
          sendResponse={receiveResponse}
          storeCustomerData={storeCustomerData}
          b2BChallanOrder={b2BChallanOrder}
          storeCreatedDate={storeCreatedDate}
        />
        <OrderUnprocessedQrCode
          setOrderUnprocessedQrCode={setOrderUnprocessedQrCode}
          orderUnprocessedQrCode={orderUnprocessedQrCode}
          selectedUnprocessedQrCodeItems={selectedUnprocessedQrCodeItems}
          storeId={storeId}
          storeUserId={storeUserId}
          storeCustomerId={storeCustomerId}
          processTime={processTime}
          bookingOrderId={bookingOrderId}
          sendResponse={receiveResponse}
        />
        <SuccessModal
          setModalVisible={setModalVisible}
          modalVisible={modalVisible}
          status={modalStatusText}
          text={modalText}
        />
        <OrderCancelModal
          setCancelOrderModal={setCancelOrderModal}
          cancelOrderModal={cancelOrderModal}
          sendDataToOrderInfoPage={receiveDataFromCancelModal}
          storeId={storeId}
          storeCustomerId={storeCustomerId}
          bookingOrderId={bookingOrderId}
        />
        {userRole === "BY_STORE" ? (
          <>
            {collectPaymentModalVisible && (
              <CollectPayment
                setCollectPaymentModalVisible={setCollectPaymentModalVisible}
                collectPaymentModalVisible={collectPaymentModalVisible}
                balanceAmount={orderInfoDetailsBalanceAmount.balanceAmount}
                storeCustomerId={storeCustomerId}
                storeId={storeId}
                storeUserId={storeUserId}
                bookingOrderId={bookingOrderId}
                sendResponse={receiveResponse}
                sendResponseQrPayment={receiveResponseCollectPaymentQrCode}
                onClose={() => {
                  fetchCustomerSingleOrder();
                  fetchStoreCustomerGetInfo();
                }}
                deliveryDiscount={deliveryDiscount}
                enableUserAccountDeliveryDiscount={
                  enableUserAccountDeliveryDiscount
                }
                enabledCreatePaymentLink={enabledCreatePaymentLink}
                brandId={brandId}
                enabledSubscriptionDiscountOnDelivery={
                  enabledSubscriptionDiscountOnDelivery
                }
                subscriptionDiscount={customerOrdersData.subscriptionDiscount}
                appliedSubscriptionDiscount={
                  customerOrdersData.appliedSubscriptionDiscount
                }
                paidAmount={customerOrdersData.paidAmount}
                userProfileData={userProfileData}
                enabledApplySubscriptionWithPackage={enabledApplySubscriptionWithPackage}
                enabledAutoApplySubscriptionWithPackage={enabledAutoApplySubscriptionWithPackage}
                orderPackageData={orderPackageData}
                enabledUPIAccount={enabledUPIAccount}
                upiAccountLink={upiAccountLink}
                upiAccountId={upiAccountId}
                upiAccountName={upiAccountName}
                bookingOrderNo={customerOrdersData?.orderNo}
                enabledQRDeviceModal={enabledQRDeviceModal}
                orderSubscriptionInfo={orderSubscriptionInfo}
                enabledAmountRoundOff={enabledAmountRoundOff}
              />
            )}
            {collectPaymentSubscriptionClosedModalVisible && (
              <CollectPaymentSubscriptionClosedModal
                setCollectPaymentSubscriptionClosedModalVisible={setCollectPaymentSubscriptionClosedModalVisible}
                collectPaymentSubscriptionClosedModalVisible={collectPaymentSubscriptionClosedModalVisible}
                balanceAmount={orderInfoDetailsBalanceAmount.balanceAmount}
                storeCustomerId={storeCustomerId}
                storeId={storeId}
                storeUserId={storeUserId}
                bookingOrderId={bookingOrderId}
                sendResponse={receiveResponse}
                sendResponseQrPayment={receiveResponseCollectPaymentQrCode}
                onClose={() => {
                  fetchCustomerSingleOrder();
                  fetchStoreCustomerGetInfo();
                }}
                deliveryDiscount={deliveryDiscount}
                enableUserAccountDeliveryDiscount={
                  enableUserAccountDeliveryDiscount
                }
                enabledCreatePaymentLink={enabledCreatePaymentLink}
                brandId={brandId}
                enabledSubscriptionDiscountOnDelivery={
                  enabledSubscriptionDiscountOnDelivery
                }
                subscriptionDiscount={customerOrdersData.subscriptionDiscount}
                appliedSubscriptionDiscount={
                  customerOrdersData.appliedSubscriptionDiscount
                }
                paidAmount={customerOrdersData.paidAmount}
                userProfileData={userProfileData}
                enabledApplySubscriptionWithPackage={enabledApplySubscriptionWithPackage}
                enabledAutoApplySubscriptionWithPackage={enabledAutoApplySubscriptionWithPackage}
                orderPackageData={orderPackageData}
                enabledUPIAccount={enabledUPIAccount}
                upiAccountLink={upiAccountLink}
                upiAccountId={upiAccountId}
                upiAccountName={upiAccountName}
                bookingOrderNo={customerOrdersData?.orderNo}
                enabledQRDeviceModal={enabledQRDeviceModal}
                orderSubscriptionInfo={orderSubscriptionInfo}
                enabledAmountRoundOff={enabledAmountRoundOff}
              />
            )}
          </>
        ) : (
          <React.Fragment>
            {customerOrdersData.status === "DELIVERED"
              ? collectPaymentModalVisible && (
                <CollectPayment
                  setCollectPaymentModalVisible={
                    setCollectPaymentModalVisible
                  }
                  collectPaymentModalVisible={collectPaymentModalVisible}
                  balanceAmount={orderInfoDetailsBalanceAmount.balanceAmount}
                  storeCustomerId={storeCustomerId}
                  storeId={storeId}
                  storeUserId={storeUserId}
                  bookingOrderId={bookingOrderId}
                  sendResponse={receiveResponse}
                  sendResponseQrPayment={receiveResponseCollectPaymentQrCode}
                  onClose={() => {
                    fetchCustomerSingleOrder();
                    fetchStoreCustomerGetInfo();
                  }}
                  deliveryDiscount={deliveryDiscount}
                  enableUserAccountDeliveryDiscount={
                    enableUserAccountDeliveryDiscount
                  }
                  enabledCreatePaymentLink={enabledCreatePaymentLink}
                  brandId={brandId}
                  userProfileData={userProfileData}
                  enabledApplySubscriptionWithPackage={enabledApplySubscriptionWithPackage}
                  enabledAutoApplySubscriptionWithPackage={enabledAutoApplySubscriptionWithPackage}
                  orderPackageData={orderPackageData}
                  enabledUPIAccount={enabledUPIAccount}
                  upiAccountName={upiAccountName}
                  upiAccountId={upiAccountId}
                  bookingOrderNo={customerOrdersData?.orderNo}
                  enabledQRDeviceModal={enabledQRDeviceModal}
                  orderSubscriptionInfo={orderSubscriptionInfo}
                  enabledAmountRoundOff={enabledAmountRoundOff}
                />
              )
              : {
                /* <RiderCollectPayment
              setCollectPaymentModalVisible={setCollectPaymentModalVisible}
              collectPaymentModalVisible={collectPaymentModalVisible}
              balanceAmount={orderInfoDetailsBalanceAmount.balanceAmount}
              storeCustomerId={storeCustomerId}
              storeId={storeId}
              storeUserId={storeUserId}
              bookingOrderId={bookingOrderId}
              sendResponse={receiveResponse}
              onClose={() => {
                fetchCustomerSingleOrder();
                fetchStoreCustomerGetInfo();
              }}
              mobileNumber={CustomerInformation.mobile}
              customerName={
                CustomerInformation.firstName +
                ' ' +
                CustomerInformation.lastName
              }
              riderDeliveryDiscount={riderDeliveryDiscount}
              partialPaymentByRider={partialPaymentByRider}
              enableUserAccountDeliveryDiscount={
                enableUserAccountDeliveryDiscount
              }
              enableDeliveryVerification={enableDeliveryVerification}
              enableDeliveryVerificationByRider={
                enableDeliveryVerificationByRider
              }
            /> */
              }}
            {/* <DeliverOrderWithAuthCodeModal
              setDeliverOrderWithAuthCodeModalVisible={
                setDeliverOrderWithAuthCodeModalVisible
              }
              deliverOrderWithAuthCodeModalVisible={
                deliverOrderWithAuthCodeModalVisible
              }
              storeCustomerId={storeCustomerId}
              storeId={storeId}
              storeUserId={storeUserId}
              bookingOrderId={bookingOrderId}
              sendResponse={receiveResponse}
              onClose={() => {
                fetchCustomerSingleOrder();
                fetchStoreCustomerGetInfo();
              }}
              mobileNumber={CustomerInformation.mobile}
              customerName={
                CustomerInformation.firstName +
                ' ' +
                CustomerInformation.lastName
              }
              enableDeliveryVerification={enableDeliveryVerification}
              enableDeliveryVerificationByRider={
                enableDeliveryVerificationByRider
              }
            /> */}
          </React.Fragment>
        )}
      </div>
      <div className="relative mt-8">
        <div
          className="flex flex-1 flex-row gap-5 w-full py-2 fixed z-2 bottom-0"
          style={{ backgroundColor: "white" }}
        >
          <div className="flex-1 flex-row mx-4 mb-1 gap-2">
            <Button
              // onClick={() =>  handleNotificationModal('SMSMessage')}
              className="p-2 w-full text-2xl border-1 flex justify-content-center"
              style={{
                color: "#fff",
                backgroundColor: "#2B70D7",
                borderRadius: 5,
              }}
            >
              <i
                className="pi pi-book "
                style={{ fontSize: "30px", cursor: "pointer", color: "#fff" }}
              ></i>
            </Button>
            <Button
              onClick={() => handleNotificationModal("WhatsAppMessage")}
              className="p-2 w-full text-2xl border-1 flex justify-content-center"
              style={{
                color: "#fff",
                backgroundColor: "#2B70D7",
                borderRadius: 5,
              }}
            >
              <i
                className="pi pi-whatsapp "
                style={{ fontSize: "30px", cursor: "pointer", color: "#fff" }}
              ></i>
            </Button>
          </div>
        </div>
      </div>
      <OrderNotification
        setOrderNotificationVisible={setOrderNotificationVisible}
        orderNotificationVisible={orderNotificationVisible}
        mobileNumber={CustomerInformation.mobile}
        orderNotificationMessageType={orderNotificationMessageType}
        storeCustomerId={storeCustomerId}
        storeId={storeId}
        bookingOrderId={bookingOrderId}
        userRole={userRole}
      />
      <StoreMenu setVisible={setVisible} visible={visible} />
      <ButtonLink />
    </div>
  );
};

export default OrdersGarmentInfo;
